interface FileNameMismatchNoticeProps {
  rejectedFileName: string;
  accountName: string | null;
  exampleFileName: string;
}

// Renders the "file name doesn't match" notice (yellow warning box) shown
// after a rejected config upload, shared across the SettingsComp pages.
function FileNameMismatchNotice({
  rejectedFileName,
  accountName,
  exampleFileName,
}: FileNameMismatchNoticeProps) {
  return (
    <div className="mt-1 max-w-lg flex flex-col gap-2 bg-yellow100 border border-yellow500 rounded-md p-3">
      <div className="flex items-center gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-4 h-4 text-yellow500 flex-shrink-0"
          aria-hidden="true"
        >
          <path d="M12 2 1 21h22L12 2zm0 5.5a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1zM12 18a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z" />
        </svg>
        <p className="text-xs font-bold text-error">
          File name doesn&apos;t match the required format
        </p>
      </div>
      <p className="text-xs text-gray400">You uploaded: {rejectedFileName}</p>
      <p className="text-xs text-error">
        The file name must start with your OneSearch Account Name ( &quot;
        {accountName}&quot;), followed by the module name.
      </p>
      <p className="text-xs text-error">Example: {exampleFileName}</p>
      <p className="text-xs text-error">
        Please verify your file selection. (Rename and re-upload if this is
        the correct file)
      </p>
    </div>
  );
}

export default FileNameMismatchNotice;
